/**
 * @file index.tsx
 *
 * @fileoverview Renders a video gallery unavailable component.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { AlignedCenter } from '~/vcl/atoms/06-layout/01-alignment/01-align-center';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Box } from '~/vcl/atoms/07-box';
import { VideoGalleryIcon } from '~/vcl/icons/VideoGallery';
import { Text } from '~/vcl/atoms/13-text/03-text';

interface VideoNotAvailableThumbProps {
  /**
   * The current organization.
   */
  organization: OrganizationProfile;
  /**
   * The current box id.
   */
  boxId: string | undefined;
  /**
   * The index the current video is in.
   */
  index: number;
}

export default function VideoNotAvailableThumb({}: VideoNotAvailableThumbProps) {
  return (
    <Box margin={0}>
      <AlignedCenter>
        <VideoGalleryIcon
          width="36"
          height="36"
          color="gray2"
          title={
            <FormattedMessage
              id="video_gallery_overlay_title"
              defaultMessage="Play"
            />
          }
        />
        <Spacing />
        <Text textAlign="center" color="gray4" marginTop="0">
          <FormattedMessage
            id="video_gallery_error"
            defaultMessage="This video not available, please check the URL of the video."
          />
        </Text>
      </AlignedCenter>
    </Box>
  );
}
